import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';

const toClosestMultipleOf = (value: number, multiple: number): number =>
  Math.round(value) - (Math.round(value) % multiple);

export const computeStyles = (
  containerBox: DOMRect,
  container: HTMLElement | null,
): readonly SystemStyleObject[] => {
  const base: SystemStyleObject = {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    margin: 0,
    padding: 0,
    left: containerBox.left - 8,
    width: containerBox.width,
  };

  const itemSize = Math.round(container?.querySelector('li')?.getBoundingClientRect().height ?? 0);

  if (itemSize === 0) {
    return [base, { visibility: 'hidden' }];
  }

  if (window.innerHeight - containerBox.bottom < 4 * itemSize) {
    return [
      base,
      {
        bottom: window.innerHeight - containerBox.top,
        top: 'auto',
        maxHeight: toClosestMultipleOf(containerBox.top - 16, itemSize),
      },
    ];
  } else {
    return [
      base,
      {
        bottom: 'auto',
        top: containerBox.bottom - 8,
        maxHeight: toClosestMultipleOf(window.innerHeight - containerBox.bottom - 8, itemSize),
      },
    ];
  }
};
